<div class="mobile-menu">
  <div class="mobile-top-bar">
    <div class="mobile-menu-logo">
       <a [href]="onfMainLink">
         <img src="../../../../assets/images/ui-kit-img/logo-white.svg" alt="mobile-logo"/>
       </a>
    </div>
    <div class="contacts-block">
      <div class="static-block">16+</div>
      <button class="mobile-menu-close contact-item" (click)="closeModelMenu()" >
          <img src="../../../../assets/images/ui-kit-img/mobile-menu-close.svg">
      </button>
    </div>
  </div>

  <nav class="mobile-menu-nav">
    <ul>
      @if(isAuth){
        <li class="button-li login-button-li">

          <div class="mobile-menu-greetings">
            @if (profileInfo()){
            <a class="mobile-menu-account-name active" >Здравствуйте,
              {{
                (profileInfo()!.person.name.last ? profileInfo()!.person.name.first + ' ' : '')
              }}</a>
            <p class="mobile-menu-id">id:{{ profileInfo()!.person.id }}</p>
            }
          </div>

          <div class="mobile-button-wrap">
            <a [href]="environment.portalOnfUrl + '/lk'" class="button mobile-menu-login-button" style="width: 45%;"
               >Личный кабинет</a>
            <a (click)="logout()"  class="button mobile-menu-login-button exit" style="width: 45%">Выйти</a>
          </div>
        </li>
      }@else{
        <li (click)="login()" class="button-li login-button-li mobile-button-wrap "  >
          <a class="button mobile-menu-login-button"  style="width: 100%;">Войти в личный кабинет</a>
        </li>
      }

      <div class="mobile-static-nav nav-block">
        <ul>
          @for (item of tabs()?.topHeader;track item){
            <li><a [href]='item.url' [target]="item.openInNewTab ? '_blank' : '_self' " >{{item.name}}</a></li>
          }
        </ul>
      </div>
      <div class="mobile-dinamic-nav nav-block">
        <ul>
          @for (item of tabs()?.secondHeader;track item){
            <li><a [href]='item.url' [target]="item.openInNewTab ? '_blank' : '_self' " >{{item.name}}</a></li>
          }
        </ul>
      </div>
    </ul>
  </nav>
  <div class="mobile-app">
    <p>Бесплатное приложение для Android и IOS:</p>

    <a href="https://apps.rustore.ru/app/ru.onf.dobro" class="mobile-app-item">
      <img src="../../../../assets/images/ui-kit-img/rustore_logo_intro.svg" alt="RuStore">
    </a>
  </div>
</div>



